import { render } from "./TotallAnalysis.vue?vue&type=template&id=0235a276"
import script from "./TotallAnalysis.vue?vue&type=script&lang=js"
export * from "./TotallAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__